import ErrorIcon from "@/components/_icons/errorIcon";
import { useTranslations } from "next-intl";

export const GiftCardCartOrdersBanner = () => {
  const t = useTranslations("GiftCardCartOrdersBanner");
  return (
    <div className="rounded-md bg-[#FFEDED] border-[#E70000] border-[1px] py-2 px-3 flex gap-1">
      <ErrorIcon height={20} width={20} />
      <span className="ml-4 text-base">
        {t("message")}
      </span>
    </div>
  );
};
